import { render } from "./DialogAbbonamentoAdmin.vue?vue&type=template&id=3c9abb92&scoped=true"
import script from "./DialogAbbonamentoAdmin.vue?vue&type=script&lang=js"
export * from "./DialogAbbonamentoAdmin.vue?vue&type=script&lang=js"

import "./DialogAbbonamentoAdmin.vue?vue&type=style&index=0&id=3c9abb92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9abb92"]])

export default __exports__